import InteresesPage from "./InteresesPage";

export {InteresesPage}
export default InteresesPage
